import { Component, EventEmitter, Input, NO_ERRORS_SCHEMA, OnInit, Output, ViewChild } from '@angular/core';

import { AuthorizationService } from '../../../services/authorization.service';
import { EventSearchApplicationHelper } from '../helpers/event-search.applicationHelper';

@Component({
  selector: 'app-eventsearch-applicationselection',
  template: '<p-dropdown [disabled]="disableDropdown" [(ngModel)]="model" [options]="applicationTypes" [placeholder]="placeholder" (onChange)="onOptionsChange($event)"></p-dropdown>' +
            '<button [disabled]="disableApply" class="btn btn-default hover" type="button" (click)="onClick()">Apply</button>',
})
export class EventSearchApplicationSelectionComponent {
  readonly PLACEHOLDER = 'Select Option';
  model: any;
  @Input() disableDropdown: boolean;
  @Input() disableApply: boolean;
  @Output() onSelectValue: EventEmitter<string> = new EventEmitter<string>();
  @Output() onApply: EventEmitter<any> = new EventEmitter<any>();

  placeholder = this.PLACEHOLDER;

  readonly applicationHelper: EventSearchApplicationHelper;
  readonly applicationTypes: any[];

  constructor(private authorizationService: AuthorizationService) {
    this.applicationHelper = new EventSearchApplicationHelper(this.authorizationService);
    this.applicationTypes = this.applicationHelper.options;
   }

  onOptionsChange(event) {
    this.onSelectValue.emit(event.value.id);
  }

  reset() {
    this.model = '';
  }

  onClick() {
    this.onApply.emit();
  }
}



// WEBPACK FOOTER //
// ./src/app/components/event-search/eventsearch-applicationselection/eventsearch-applicationselection.component.ts